import type { OrderHeader } from '@/lib/api-types'

/** What an order goes by: the SAP DocNum once the release wrote it back, else the SF name. */
export function orderNumber(order: Pick<OrderHeader, 'docNum' | 'name'>): string {
  return order.docNum ?? order.name
}
